export default __webpack_public_path__ + "0ae8906fe6b047d0dfd5378027c91ae4.png";